import { IconButton, AppBar, Toolbar, Table, TableHead, TableBody, TableRow, TableCell, Checkbox, Button, Tabs, Tab } from "@material-ui/core";
import * as React from "react";
import { Theme } from "@material-ui/core/styles";
import { observable, action, toJS } from "mobx";
import { createStyles, withStyles, WithStyles } from "@material-ui/core/styles";
import { config } from "src/config";
import { observer } from "mobx-react";
import { history } from "src/history.js";
import { SignUpEmailTemplate, CompanySettings, settingsStore, NoCompanyUsersList } from '.';
import { AdminToolBar } from '../../components';
import { companiesAdminStore } from '../CompaniesAdmin';


const styles = createStyles({
    root: {
        width: "100%",
        height: "100%",
        margin: "0 auto",
        // padding: "1.5rem",
        display: "flex",
        flexDirection: "column",
    },
    rowContainer: {
        width: "100%",
        display: "flex",
        alignContent: "center",
        margin: "0 auto",
        // padding: "3rem",
    },
    columnContainer: {
        width: "100%",
        display: "flex",
        margin: "0 auto",
        // padding: "3rem",
    },
    textField: {
        display: "flex",
        paddingRight: "24px",
    },
    roleSelect: {
        minWidth: "9rem",
    },
    companySelect: {
        minWidth: "16.5rem",
    },
    appRoleSelect: {
        minWidth: "16.5rem",
        paddingTop: "1.5rem",
    },
    formContainer: {
        width: "100%",
        padding: "1.5rem",
    },
    submitContainer: {
        width: "100%",
        display: "flex",
        flexDirection: "row-reverse",
    },
    submitButton: {
        // backgroundColor: "#2A2A55",
        // border: "1px solid #2D4D73",
        // color: "#FAFAFA",
    },
    tabRoot: {
    },
    tabsRoot: {
    },
    flexContainer: {
        height: '100%'
    }

});

@observer
class Settings extends React.Component<any> {

    public state = { current_tab: 0 };

    constructor(props: any) {
        super(props);
        settingsStore.getEmailTemplates();
        settingsStore.getAppSettings();
        settingsStore.getNoCompanyUserList();
        companiesAdminStore.retrieveCompanies();
    }

    public handleChangeTab = (event: any, value: number) => {
        this.setState({
            ...this.state,
            current_tab: value
        })
    }

    public getPageContent = (current_tab: number) => {
        switch (current_tab) {
            case (0):
                {
                    return (<SignUpEmailTemplate />)
                }
            case (1):
                {
                    return (<CompanySettings />)
                }
            case (2):
                {
                    return (<NoCompanyUsersList />)
                }
            default:
                {
                    return (<div>no tab found</div>)
                }
        }
    }

    public render() {
        const { classes } = this.props;

        const page_content = this.getPageContent(this.state.current_tab)

        const getTabs = () => {
            return (
                <Tabs
                    value={this.state.current_tab}
                    // tslint:disable-next-line: jsx-no-lambda
                    onChange={this.handleChangeTab}
                    indicatorColor="secondary"
                    textColor="secondary"
                    classes={{
                        root: classes.tabsRoot,
                        flexContainer: classes.flexContainer
                    }}
                    style={{ height: '100%' }}
                >
                    <Tab
                        classes={{
                            root: classes.tabRoot
                        }}
                        label="Email Templates"
                    />
                    <Tab
                        classes={{
                            root: classes.tabRoot,

                        }}
                        label="Company Settings"
                    />
                    <Tab
                        classes={{
                            root: classes.tabRoot,

                        }}
                        label="No Company Users"
                    />
                </Tabs>

            )
        }

        return (
            <div className={classes.root}>
                <AdminToolBar pageTitle={'Settings'} tabs={getTabs()} />
                {page_content}
            </div>
        );
    }

}

export default withStyles(styles, { withTheme: true })(Settings);


// WEBPACK FOOTER //
// ./src/modules/admin/modules/Settings/Settings.tsx